module.exports = __webpack_public_path__ + "img/hotel-stay.40516f0f.png";